'use client';
import React, { useState } from 'react';

// Define type for options
type Option = {
  text: string;
  href?: string;
  onClick?: () => void;
};

// Define type for ButtonDropdownProps
type ButtonDropdownProps = {
  options: Option[];
  buttonText: string;
  icon: React.ReactNode;
};

const ButtonDropdown: React.FC<ButtonDropdownProps> = ({ options, buttonText, icon }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button className="p-2 bg-gray-800 text-white rounded flex items-center" onClick={toggleDropdown}>
        <span className="mr-1">{icon}</span>
        {buttonText}
      </button>
      {isOpen && (
        <div className="bg-white text-black p-4 rounded shadow">
          <ul>
            {options.map((option, index) => (
              <li key={index} className="cursor-pointer">
                {option.href ? <a href={option.href}>{option.text}</a> : <a onClick={option.onClick}>{option.text}</a>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ButtonDropdown;
